/**
 * 公共 token 配置
 * - 提供 token 获取/设置/清理
 * - 提供可选的 Basic(Authorization) 头构建
 *
 * Token 使用 sessionStorage，按浏览器页签隔离，避免多账号多开时互相覆盖。
 * client/tenant 等仍可用 localStorage（与登录态无关）。
 */

const ACCESS_TOKEN_KEY = "access_token";
const TOKEN_TYPE_KEY = "token_type";

// 可选：用于构建 Basic Authorization（如果你们后端也需要 clientId/clientSecret）
const CLIENT_ID_KEY = "client_id";
const CLIENT_SECRET_KEY = "client_secret";

// 可选：用于请求头 Tenant / appId（和你给的 axios.js 保持一致的字段名）
const TENANT_ID_KEY = "tenant_id";
const APP_ID_KEY = "app_id";

function safeLocalStorageGet(key) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
}

function safeLocalStorageSet(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    // ignore
  }
}

function safeLocalStorageRemove(key) {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    // ignore
  }
}

function safeSessionStorageGet(key) {
  try {
    return sessionStorage.getItem(key);
  } catch (e) {
    return null;
  }
}

function safeSessionStorageSet(key, value) {
  try {
    sessionStorage.setItem(key, value);
  } catch (e) {
    // ignore
  }
}

function safeSessionStorageRemove(key) {
  try {
    sessionStorage.removeItem(key);
  } catch (e) {
    // ignore
  }
}

export function setToken({ accessToken, tokenType } = {}) {
  if (accessToken != null) safeSessionStorageSet(ACCESS_TOKEN_KEY, String(accessToken));
  if (tokenType != null) safeSessionStorageSet(TOKEN_TYPE_KEY, String(tokenType));
}

export function getToken() {
  return safeSessionStorageGet(ACCESS_TOKEN_KEY) || "";
}

export function getTokenType() {
  return safeSessionStorageGet(TOKEN_TYPE_KEY) || "";
}

export function clearToken() {
  safeSessionStorageRemove(ACCESS_TOKEN_KEY);
  safeSessionStorageRemove(TOKEN_TYPE_KEY);
  safeLocalStorageRemove(ACCESS_TOKEN_KEY);
  safeLocalStorageRemove(TOKEN_TYPE_KEY);
}

export function setClientCredential({ clientId, clientSecret } = {}) {
  if (clientId != null) safeLocalStorageSet(CLIENT_ID_KEY, String(clientId));
  if (clientSecret != null)
    safeLocalStorageSet(CLIENT_SECRET_KEY, String(clientSecret));
}

export function getBasicAuthHeader() {
  const clientId = safeLocalStorageGet(CLIENT_ID_KEY);
  const clientSecret = safeLocalStorageGet(CLIENT_SECRET_KEY);
  if (!clientId || !clientSecret) return "";
  // btoa 只适用于 ASCII；clientId/clientSecret 一般满足该假设
  return `Basic ${btoa(`${clientId}:${clientSecret}`)}`;
}

export function setTenantId(tenantId) {
  if (tenantId == null) return;
  safeLocalStorageSet(TENANT_ID_KEY, String(tenantId));
}

export function getTenantId() {
  return safeLocalStorageGet(TENANT_ID_KEY) || "epro";
}

export function setAppId(appId) {
  if (appId == null) return;
  safeLocalStorageSet(APP_ID_KEY, String(appId));
}

export function getAppId() {
  return safeLocalStorageGet(APP_ID_KEY) || "Admin";
}

